import { getChainName } from '@ui/constants/chain';
import { useDataChainId } from '@ui/hooks/datachain';
import { useCallback, useEffect } from 'react';
import { useAccount } from 'wagmi';

import { identifyUserInfo } from '../common';

export const useIdentifyPostHogUserOnConnect = () => {
  const { isConnected } = useAccount();
  const identifyPostHogUser = useIdentifyPostHogUser();

  useEffect(() => {
    if (isConnected) {
      identifyPostHogUser();
    }

    return () => {};
  }, [identifyPostHogUser, isConnected]);
};

export const useIdentifyPostHogUser = () => {
  const dataChainId = useDataChainId();
  const { address, isConnected, connector } = useAccount();

  const logPostHogUserInfo = useCallback(() => {
    if (address && isConnected) {
      identifyUserInfo({
        address: address,
        chainName: getChainName(dataChainId),
        chainId: dataChainId + '',
        connectWallet: connector?.name,
      });
    }
  }, [address, connector, dataChainId, isConnected]);

  return logPostHogUserInfo;
};
